<template>
    <div class="joined-shops">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="joined-shops__header">
                        <TitleDescription title="Shops That Already Joined Us"/>
                        <div class="d-sm-flex d-none joined-shops__header__slider-arrow">
                            <div class="joined-shops__slider-arrow-prev joined-shops__slider-arrows"><Icon icon="landingpage-cards-arrow"/></div>
                            <div class="joined-shops__slider-arrow-next joined-shops__slider-arrows"><Icon icon="landingpage-cards-arrow"/></div>
                        </div>
                    </div>
                    <div v-if="joined" class="joined-shops__list">
                         <swiper @click.native="handleSlideClick" class="swiper joined-shop__swiper" :options="swiperOptionJoinedShops" id="swiperJoinedShops">
                            <swiper-slide
                                v-for="(item, index) in joined" 
                                :key="index"
                                :id="`joined-shop-${index}`"
                                class="joined-shop__item"
                            >   
                                <Shop :shop="item" card-location="LandingPage"/>   
                            </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                        </swiper>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
import TitleDescription from '@/components/Ecommerce/TitleDescription'
import Shop from '@/components/Ecommerce/Shops/Shop'
import useJoinedShops from './useJoinedShops' 
import {swiperOptionJoinedShops} from '../slidersInit'
import { onMounted } from '@vue/composition-api'
import { useStore } from '../../../../core/hooks'
export default {
    name: 'JoinedShops',
    components: {
        TitleDescription,
        Shop,
        Icon
    },
    setup() {
        const {store} = useStore()
        const {joined, getJoinedShops}  = useJoinedShops() 
        onMounted(() => {
            getJoinedShops()
        })
        const handleSlideClick = (e) => {
            if(e.target.localName === 'span') {
                return
            }
            store.commit('TOGGLE_MODAL',['sign-up', {
                openedFrom: 'Landing Page Joined Shops'
            }])
            return
        }
        return {
            joined,
            swiperOptionJoinedShops,
            handleSlideClick
        }
    }
}
</script>

<style lang="scss" scoped>
$joined_shops_padding: 96px 0;
$joined_shops_padding_mob: 72px 0;
$joined_shops_padding_sm: 56px 0;
$joined_shops_white_color: #ffffff;
$joined_shops_transition: all 0.2s ease;
.joined-shops {
    --title-fontsize: 28px;
    --title-margin-bottom: 0;

    @media (max-width: 768px) {
        padding: $joined_shops_padding_mob;
    }
    @media (max-width: 576px) {
        --title-margin-bottom: 8px;
        --title-fontsize: 20px;
        --title-lineheight: 24px;
        padding: $joined_shops_padding_sm;
    }
    
    padding: $joined_shops_padding;
    background: $joined_shops_white_color;
    &__header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        align-items: center;
        padding: 0 15px;
        @media (max-width: 768px) {
            padding: 0;
            margin-bottom: 32px;
        }
        @media (max-width: 576px) {
            text-align: center;
            justify-content: center;
            margin-bottom: 16px;
        }
        &__slider-arrow {
            display: flex;
            align-items: center;
            .joined-shops__slider-arrows {
                display: flex;
                align-items: center;
                justify-content: center;
                &:focus {
                    outline: 0;
                }
                img {
                    filter: grayscale(1);
                    transition: $joined_shops_transition;
                    &:hover {
                        filter: grayscale(0);
                    }
                }
            }
            .joined-shops__slider-arrow-prev {
                margin-right: 12px;
            }
            .joined-shops__slider-arrow-next { 
                transform: rotate(180deg);
            }
        }
    }
}
</style>